import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
	alert: {
		margin: '10px 10px -10px 10px',
	},
	filesContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		minHeight: 220,
		position: 'relative',
	},
	filesContainerDragOver: {
		alignItems: 'center',
		background: 'rgba(255, 255, 255, 0.8)',
		color: '#757575',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		justifyContent: 'center',
		position: 'absolute',
		transition: 'opacity 0.4s ease-out',
		width: '100%',
	},
	dragOverIcon: {
		marginBottom: 10,
	},
	filesCard: {
		margin: '40px 10px',
		overflow: 'visible',
		position: 'relative',
	},
	filesEmptyIcon: {
		left: '50%',
		position: 'absolute',
		transform: 'translate(-50%)',
		top: '50%',
	},
	filesItem: {
		flexDirection: 'column',
		margin: 10,
		width: 200,
		height: 248,

		'@media(max-width: 1400px)': {
			width: "180px",
		},
	},
	filesItemImageData: {
		width: '100%',
		height: 200,
		backgroundColor: "#3d4852",
		borderTopLeftRadius: 5,
		borderTopRightRadius: 5,
		position: "relative",
		cursor: "pointer",
	},
	filesItemImage: {
		width: "100%",
		height: "100%",
		backgroundPosition: "50%",
		backgroundSize: "contain",
		backgroundRepeat: "no-repeat",
	},
	filesItemName: {
		pointerEvents: 'none',
		position: "absolute",
		zIndex: 15,
		height: "100px",
		width: "100%",
		fontWeight: 700,
		fontSize: "12px",
		whiteSpace: "nowrap",
		background: "linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0, rgba(0, 0, 0, 0.7) 29%, transparent)",
		backgroundBlendMode: "multiply",
		color: "#f5f5f5",

		"&& > div": {
			margin: "10px",
			overflow: ["hidden", "hidden"],
			textOverflow: "ellipsis",
		},
	},
	filesInputUploadIcon: {
		height: 14,
		marginRight: 5,
		pointerEvents: 'none',
		width: 20,
	},
	filesItemSize: {
		alignItems: 'center',
		color: "#e6e6e6",
		display: 'flex',
		fontSize: "11px",
		justifyContent: 'center',
		marginTop: 5,
		pointerEvents: 'none',
	},
	filesItemRemove: {
		position: "absolute",
		bottom: "0",
		right: "0",
		color: "white",
		backgroundColor: "#3d4852",
		opacity: 0.75,
		borderRadius: "9999px",
		margin: "4px",
		padding: "4px",
		width: "22px",
		height: "22px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		border: "1.5px solid transparent",
		transition: "border 200ms ease",
		cursor: "pointer",
		"&:hover": { border: "1.5px solid #fff" },
		'&& svg': { stroke: "currentColor", height: "18px", width: "18px" }
	},
});